import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectivesModule } from '../directives/directives.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from '../pipes/pipes.module';
import { DefaultPriceMarginComponent } from './default-price-margin.component';



@NgModule({
  declarations: [DefaultPriceMarginComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    DirectivesModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule
  ],
  providers: [],
  exports: [DefaultPriceMarginComponent]
})
export class DefaultPriceMarginModule {
  customElementComponent: Type<any> = DefaultPriceMarginComponent;
}
